import React from 'react'
import {Switch,Route} from "react-router-dom";
import Login from './Login'
import ResetPassword from './ResetPassword'

export default function Render() {
	return (
		<Switch>
			<Route component={ResetPassword} path="/admin/reset"/>
			<Route component={Login} path="/admin" exact/>
		</Switch>
	)
}
